import { vars, InfoButton, Tooltip, Text } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { buttonInfo } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStatusData = (departureAirport, isAirportAvailable, isCardSelected, text) => {
  if (isCardSelected && isAirportAvailable) {
    return {
      text: text.addedStatus,
      icon: /*#__PURE__*/_jsx(CheckCircle, {
        "aria-hidden": true,
        color: vars.colors.signal.positive.light,
        "data-testid": "add-icon",
        size: 20,
        weight: "regular"
      })
    };
  }
  if (isAirportAvailable) {
    return {
      text: text.availableStatus
    };
  }
  return {
    text: text.unavailableStatus,
    icon: /*#__PURE__*/_jsx(Tooltip, {
      "aria-live": "polite",
      content: text.statusTooltip,
      title: "tooltip",
      trigger: "click",
      children: /*#__PURE__*/_jsx(InfoButton, {
        className: buttonInfo,
        color: vars.colors.signal.caution.dark,
        "data-testid": "unavailable-icon",
        label: `${departureAirport} ${text.unavailableStatus}`
      })
    })
  };
};
const AvailabilityStatus = _ref => {
  let {
    departureAirport,
    text,
    isAirportAvailable,
    isCardSelected
  } = _ref;
  const statusData = useStatusData(departureAirport, isAirportAvailable, isCardSelected, text);
  return /*#__PURE__*/_jsxs("div", {
    className: "airportStatus",
    children: [/*#__PURE__*/_jsx(Text, {
      className: "statusText",
      children: statusData.text
    }), statusData.icon]
  });
};
export default AvailabilityStatus;
//# sourceMappingURL=AvailabilityStatus.js.map